// Centralized SVG imports for dynamic usage
// This file provides a mapping of provider/server types to their SVG files
// Using ?url suffix to get file paths for use with react-inlinesvg

import anfDefaultSvg from './anf-default.svg?url';
import awsDefaultSvg from './aws-default.svg?url';
import azureDefaultSvg from './azure-default.svg?url';
import azureDataLakeDefaultSvg from './azure_data_lake-default.svg?url';
import boxDefaultSvg from './box-default.svg?url';
import cifsDefaultSvg from './cifs-default.svg?url';
import cvoDefaultSvg from './cvo-default.svg?url';
import cvsDefaultSvg from './cvs-default.svg?url';
import dataBrokerDefaultSvg from './data-broker-default.svg?url';
import directoryDefaultSvg from './directory-default.svg?url';
import efsDefaultSvg from './efs-default.svg?url';
import fileServerDefaultSvg from './file-server-default.svg?url';
import fsxDefaultSvg from './fsx-default.svg?url';
import gcpDefaultSvg from './gcp-default.svg?url';
import gdriveDefaultSvg from './gdrive-default.svg?url';
import ibmDefaultSvg from './ibm-default.svg?url';
import nfsDefaultSvg from './nfs-default.svg?url';
import onpremDefaultSvg from './onprem-default.svg?url';
import ontapDefaultSvg from './ontap-default.svg?url';
import s3DefaultSvg from './s3-default.svg?url';
import sftpDefaultSvg from './sftp-default.svg?url';
import sgwsDefaultSvg from './sgws-default.svg?url';

// Marketplace icons for subscription
import awsMarketplaceSvg from './aws-marketplace.svg?url';
import azureMarketplaceSvg from './azure-marketplace.svg?url';
import marketplaceSvg from './marketplace.svg?url';

// Table icons for dashboard
import anfTableSvg from './anf-table.svg?url';
import anfTableSecureSvg from './anf-table-secure.svg?url';
import azureTableSvg from './azure-table.svg?url';
import azureDataLakeTableSvg from './azure_data_lake-table.svg?url';
import boxTableSvg from './box-table.svg?url';
import cifsTableSvg from './cifs-table.svg?url';
import cvoTableSvg from './cvo-table.svg?url';
import cvoTableSecureSvg from './cvo-table-secure.svg?url';
import cvsTableSvg from './cvs-table.svg?url';
import cvsTableSecureSvg from './cvs-table-secure.svg?url';
import efsTableSvg from './efs-table.svg?url';
import efsTableSecureSvg from './efs-table-secure.svg?url';
import fsxTableSvg from './fsx-table.svg?url';
import fsxTableSecureSvg from './fsx-table-secure.svg?url';
import gcpTableSvg from './gcp-table.svg?url';
import gdriveTableSvg from './gdrive-table.svg?url';
import genericTableSvg from './generic-table.svg?url';
import ibmTableSvg from './ibm-table.svg?url';
import nfsTableSvg from './nfs-table.svg?url';
import nfsTableSecureSvg from './nfs-table-secure.svg?url';
import onpremTableSvg from './onprem-table.svg?url';
import ontapTableSvg from './ontap-table.svg?url';
import s3TableSvg from './s3-table.svg?url';
import sftpTableSvg from './sftp-table.svg?url';
import sgwsTableSvg from './sgws-table.svg?url';

export const defaultSvgs = {
  'anf': anfDefaultSvg,
  'aws': awsDefaultSvg,
  'azure': azureDefaultSvg,
  'azure_data_lake': azureDataLakeDefaultSvg,
  'box': boxDefaultSvg,
  'cifs': cifsDefaultSvg,
  'cvo': cvoDefaultSvg,
  'cvs': cvsDefaultSvg,
  'data-broker': dataBrokerDefaultSvg,
  'directory': directoryDefaultSvg,
  'efs': efsDefaultSvg,
  'file-server': fileServerDefaultSvg,
  'fsx': fsxDefaultSvg,
  'gcp': gcpDefaultSvg,
  'gdrive': gdriveDefaultSvg,
  'ibm': ibmDefaultSvg,
  'nfs': nfsDefaultSvg,
  'onprem': onpremDefaultSvg,
  'ontap': ontapDefaultSvg,
  's3': s3DefaultSvg,
  'sftp': sftpDefaultSvg,
  'sgws': sgwsDefaultSvg,
};

export const marketplaceSvgs = {
  'aws-marketplace': awsMarketplaceSvg,
  'azure-marketplace': azureMarketplaceSvg,
};

export const tableSvgs = {
  'anf-table': anfTableSvg,
  'anf-table-secure': anfTableSecureSvg,
  'azure-table': azureTableSvg,
  'azure_data_lake-table': azureDataLakeTableSvg,
  'box-table': boxTableSvg,
  'cifs-table': cifsTableSvg,
  'cvo-table': cvoTableSvg,
  'cvo-table-secure': cvoTableSecureSvg,
  'cvs-table': cvsTableSvg,
  'cvs-table-secure': cvsTableSecureSvg,
  'efs-table': efsTableSvg,
  'efs-table-secure': efsTableSecureSvg,
  'fsx-table': fsxTableSvg,
  'fsx-table-secure': fsxTableSecureSvg,
  'gcp-table': gcpTableSvg,
  'gdrive-table': gdriveTableSvg,
  'generic-table': genericTableSvg,
  'ibm-table': ibmTableSvg,
  'nfs-table': nfsTableSvg,
  'nfs-table-secure': nfsTableSecureSvg,
  'onprem-table': onpremTableSvg,
  'ontap-table': ontapTableSvg,
  's3-table': s3TableSvg,
  'sftp-table': sftpTableSvg,
  'sgws-table': sgwsTableSvg,
};

// Helper function to get default SVG by provider/server type
export const getDefaultSvg = (serverType) => {
  return defaultSvgs[serverType] || defaultSvgs['file-server'];
};

// Helper function to get marketplace SVG with fallback to generic marketplace icon
export const getMarketplaceSvg = (iconFileName) => {
  return marketplaceSvgs[iconFileName] || marketplaceSvg;
};

// Helper function to get table SVG
export const getTableSvg = (protocol, isSecureRelationship) => {
  const svgName = `${protocol}-${isSecureRelationship ? "table-secure" : "table"}`;
  return tableSvgs[svgName] || tableSvgs['generic-table'];
};
